import searchAtomPair from 'atoms/search-atom';
import { useMemo } from 'react';
import { StateTaxesQueryResponse } from 'types/api-responses';

export const useStateTaxesSearchAtom = () => {
  return useMemo(() => {
    return searchAtomPair<StateTaxesQueryResponse>('stateTaxes', {});
  }, []);
};
